import { trpc } from './trpc'

export const useValidateCryptoAddress = () => {
    return trpc.crypto.validateAddress.useMutation()
}
